import { render, staticRenderFns } from "./WizardProgressComponent.vue?vue&type=template&id=3635e966&scoped=true&"
import script from "./WizardProgressComponent.vue?vue&type=script&lang=js&"
export * from "./WizardProgressComponent.vue?vue&type=script&lang=js&"
import style0 from "./WizardProgressComponent.vue?vue&type=style&index=0&id=3635e966&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3635e966",
  null
  
)

export default component.exports